<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sifreGuncelle">Şifre Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yoneticiTanimlama">Yönetici Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yoneticiDetay">yönetici Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yoneticiListesi">yönetici listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yoneticiDurumGuncelle">yönetici durum güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yoneticiGuncelle">yönetici güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yetkiList">Yetki Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="yetkiAtama">Yetkilendirme
            </el-button>

        </el-col>
    </div>
</template>

<script>
    import yonetimService from '../../../WSProvider/YoneticiService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataExon = "";
    export default {
        name: "YonetimDetay",
        methods: {
            sifreGuncelle() {
                yonetimService.sifreGuncelle("test", "123");
            },
            yoneticiTanimlama() {
                yonetimService.yoneticiTanimlama(2, "1111111123", "", "sume", "1234", "Sümeyye Şahin", "teknik", "sum@gmail.com", "", "", "");
            },
            yoneticiListesi() {
                yonetimService.yoneticiList();
            },
            yoneticiDetay() {
                yonetimService.yoneticiDetay(1001);
            },
            yoneticiDurumGuncelle() {
                yonetimService.yoneticiDurumGuncelle(1001, 0);
            },
            yoneticiGuncelle() {
                let updateList = [{
                    type: "adSoyad",
                    value: "Saniye"
                }, {
                    type: "cepTelefon",
                    value: "6584156541 "
                }];
                yonetimService.yoneticiGuncelle(1001, updateList);
            },
            yetkiList() {
                yonetimService.yetkiList();
            },
            yetkiAtama() {
                yonetimService.yetkiAtama(1003, "YK-859359", 1);
            },
        }
    }
</script>

<style scoped>

</style>